import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import {AuthService} from "../../login/services/auth.service";
import { DacConfig } from 'app/shared/services/dac-config.service';

@Component({
  selector: 'app-assessments',
  templateUrl: './assessments.component.html',
  styleUrls: ['./assessments.component.css']
})
export class AssessmentsComponent implements OnInit {

  constructor(
    private authService:AuthService
    ,private router:Router
    ,private dacConfig:DacConfig
  ) { }

  ngOnInit() {
  }

  public shouldShowHeader() {
    return !this.dacConfig.seamlessMode;
  }

  public get notSeamless() {
    return !this.dacConfig.seamlessMode;
  }
}



// WEBPACK FOOTER //
// ./src/app/assessments/assessments/assessments.component.ts